module.exports = __webpack_public_path__ + "media/images/bg/group-course-wave-bdde6198aed17382028ea55623631cfd.svg";